const items = [
    { image: "/mainImages/playbutton/lsr-aware.png", url: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/LSR+Aware.mp4" },
    { image: "/mainImages/playbutton/lsr-pro.png", url: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/LSR+Pro.mp4" },
    { image: "/mainImages/playbutton/driving-aware-all-roads.png", url: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Driving+Aware.mp4" },
    { image: "/mainImages/playbutton/driving-pro-black-top.png", url: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Black+Top+Driving+Pro.mp4" },
    { image: "/mainImages/playbutton/driving-pro-graded-road.png", url: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Graded+Road+Driving+Pro.mp4" },
    { image: "/mainImages/playbutton/process-safety.png", url: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/VIRSAT+Process+Safety+3.mp4" },
    { image: "/mainImages/playbutton/lsr-roads.png", url: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Life-Saving+Rules+Road+1.mp4" }
];

const GameVids = () => {
  return (
    <div className="gameplay-section">
      <p className="module-title"> Sample Vidoes</p>
      <div className="play-gap">
        <div className="checkout-container-business">
          {items.map((item, index) => {
            const fileName = item.image.split("/").pop().split(".")[0];
            return (
              <div key={index} className="item">
                {item.url ? (
                  <a href={item.url} target="_blank" rel="noopener noreferrer" className="image-container">
                    <img src={item.image} alt={fileName} className="game-image"/>
                    <div className="play-button-overlay">
                      <div className="play-button">▶</div>
                      <div className="description-box-play" id="color-change">Play Video</div>
                    </div>
                  </a>
                ) : (
                  <div className="image-container">
                    <img src={item.image} alt={fileName} className="game-image"/>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GameVids;